import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	editButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	submitButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	editButtonLabel: {
		id: 'inline-edit-lite.read-view.edit-button-label',
		defaultMessage: 'Edit',
		description:
			'Aria label to be used by assistive technologies when interacting with the edit button.',
	},
	confirmButtonLabel: {
		id: 'inline-edit-lite.edit-view.confirm-button-label',
		defaultMessage: 'Confirm',
		description:
			'Aria label to be used by assistive technologies when interacting with the confirm button.',
	},
	cancelButtonLabel: {
		id: 'inline-edit-lite.edit-view.cancel-button-label',
		defaultMessage: 'Cancel',
		description:
			'Aria label to be used by assistive technologies when interacting with the cancel button.',
	},
	submitButtonLabel: {
		id: 'inline-edit-lite.edit-view.submit-button-label',
		defaultMessage: 'Submit',
		description:
			'Aria label to be used by assistive technologies when interacting with the submit button.',
	},
});
export default messages;
